<template>
    <v-container fluid class="main-container container-fixed h-100 d-block pa-0">
        <div class="content-block">
            <HomeTitle v-model="room" @add-modal="openAddDevice"></HomeTitle>
            <v-flex xs12 px-5 my-3>
                <v-btn class="yellow-btn main-text" @click="openUser">
                    Интерфейс пользователя
                </v-btn>
            </v-flex>
            <BottomSheetRoom
                v-if="locations && locations.length > 6"
                ref="BottomSheet"
                :activeGroup="activeGroup"
                :locations="locations"
                :offset="hasOffline ? 3 : 2"
                @setRoom="setActiveGroup"
            ></BottomSheetRoom>
            <v-layout row class="locations-group-row" v-dragscroll.x>
                <v-btn
                    v-if="locations && locations.length > 6"
                    class="locations-group__btn mx-1"
                    active-class="locations-group__btn-active"
                    :input-value="hasOffline ? activeGroup > 2 : activeGroup > 1"
                    depressed
                    rounded
                    @click="openSheet"
                >
                    {{chosenLocation}}
                    <div v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')" class="d-inline-flex ml-2" />
                </v-btn>
                <v-btn
                    class="locations-group__btn mx-1"
                    active-class="locations-group__btn-active"
                    v-for="(location, index) in locationsScroll"
                    :key="index"
                    :input-value="activeGroup == index"
                    depressed
                    rounded
                    :id="`location${index}`"
                    @click="setActiveGroup(index)"
                >
                    <div
                        v-if="hasOffline && location == 'Неисправные'"
                        v-html="require('!html-loader!@/assets/icons/info_icon.svg')"
                        class="d-inline-flex size-22"
                    />
                    {{ location }}
                </v-btn>
            </v-layout>
            <v-layout
                id="scroll-target"
                class="devices-list scroll-layout px-6 mt-6"
                column
                v-if="deviceTypes"
                v-scroll:#scroll-target="onScroll"
            >
                <div class="w-100">
                    <v-text-field
                        v-model="searchField"
                        placeholder="Поиск устройства"
                        class="dark-input dark-round-input"
                        dense
                        hide-details
                        @change="setSearch"
                        @input="setSearch"
                        @keypress.enter="setSearch"
                    >
                        <template v-slot:append>
                            <div
                                v-html="require('!html-loader!@/assets/icons/search_icon.svg')"
                                class="d-inline-flex size-20"
                            />
                        </template>
                    </v-text-field>
                </div>
                <div v-if="devicesFiltered.length == 0 && activeGroup == 0" class="img-center">
                    <v-flex text-center>
                        <div
                            v-html="require('!html-loader!@/assets/images/empty-device-list.svg')"
                            class="d-inline-flex mb-8"
                        />
                        <div class="main-text text-center">
                            Вы пока не добавили ни одного <br> устройства в избранное
                        </div>
                    </v-flex>
                </div>
                <div v-else-if="devicesFiltered.length == 0 && activeGroup == 1" class="img-center">
                    <v-flex text-center>
                        <div
                            v-html="require('!html-loader!@/assets/images/empty-device-list.svg')"
                            class="d-inline-flex mb-8"
                        />
                        <div class="main-text text-center">
                            Вы пока не добавили ни одного <br> устройства
                        </div>
                    </v-flex>
                </div>
                <div v-else-if="devicesFiltered.length == 0 && searchField != ''" class="img-center">
                    <v-flex text-center>
                        <div
                            v-html="require('!html-loader!@/assets/images/empty-device-list.svg')"
                            class="d-inline-flex mb-8"
                        />
                        <div class="main-text text-center">
                            Не найдено устройств
                        </div>
                    </v-flex>
                </div>
                <div v-else :key="devicesFiltered.length">
                    <div v-for="(device, index) in devicesFiltered" :key="index">
                        <CardholderDevice v-if="device.device_type == 1" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <SwitchDevice v-if="device.device_type == 2" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <MotionSensorDevice v-if="device.device_type == 3" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <OpeningSensorDevice v-if="device.device_type == 4" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <VentilationDevice v-if="device.device_type == 5" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <LeakSensorDevice v-if="device.device_type == 6" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <ThermometerDevice v-if="device.device_type == 7" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <CurtainsDevice v-if="device.device_type == 8" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <LightingDevice v-if="device.device_type == 9" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <SocketDevice v-if="device.device_type == 10" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <FridgeDevice v-if="device.device_type == 11" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <HeatingDevice v-if="device.device_type == 12" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <WarmFloorDevice v-if="device.device_type == 13" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <WaterShutOffDevice v-if="device.device_type == 14" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <DimmableLightingDevice v-if="device.device_type == 15" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <TVDevice v-if="device.device_type == 16" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <IlluminationSensor v-if="device.device_type == 17" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <HumidityDevice v-if="device.device_type == 18" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                    </div>
                </div>
            </v-layout>
        </div>
        <ModalWaiting v-model="openModalWaiting"></ModalWaiting>
        <ModalAddDevice
            v-if="openAddDeviceModal"
            v-model="openAddDeviceModal"
            :home="room"
            :editDevice="{}"
        />
    </v-container>
</template>

<script>
import HomeTitle from "../components/HomeTitle";
import BottomSheetRoom from "@/components/BottomSheetRoom.vue";
import deviceTypes from '../plugins/deviceTypes.js';
import CardholderDevice from "@/components/devices-card/CardholderDevice";
import VentilationDevice from "@/components/devices-card/VentilationDevice";
import ThermometerDevice from "@/components/devices-card/ThermometerDevice";
import SwitchDevice from "@/components/devices-card/SwitchDevice";
import MotionSensorDevice from "@/components/devices-card/MotionSensorDevice";
import OpeningSensorDevice from "@/components/devices-card/OpeningSensorDevice";
import LeakSensorDevice from "@/components/devices-card/LeakSensorDevice";
import CurtainsDevice from "@/components/devices-card/CurtainsDevice";
import IlluminationSensor from "@/components/devices-card/IlluminationSensor";
import HumidityDevice from "@/components/devices-card/HumidityDevice";
import LightingDevice from "@/components/devices-card/LightingDevice";
import SocketDevice from "@/components/devices-card/SocketDevice";
import FridgeDevice from "@/components/devices-card/FridgeDevice";
import HeatingDevice from "@/components/devices-card/HeatingDevice";
import WarmFloorDevice from "@/components/devices-card/WarmFloorDevice";
import WaterShutOffDevice from "@/components/devices-card/WaterShutOffDevice";
import DimmableLightingDevice from "@/components/devices-card/DimmableLightingDevice";
import TVDevice from "@/components/devices-card/TVDevice";
import ModalWaiting from "@/components/modals/ModalWaiting";
import ModalAddDevice from "@/components/modals/ModalAddDevice";
import { dragscroll } from 'vue-dragscroll';

export default {
    name: "HomePage",
    directives: {
        dragscroll: dragscroll,
    },
    components: {
        HomeTitle,
        BottomSheetRoom,
        CardholderDevice,
        VentilationDevice,
        ThermometerDevice,
        SwitchDevice,
        MotionSensorDevice,
        OpeningSensorDevice,
        LeakSensorDevice,
        CurtainsDevice,
        LightingDevice,
        SocketDevice,
        FridgeDevice,
        HeatingDevice,
        WarmFloorDevice,
        WaterShutOffDevice,
        DimmableLightingDevice,
        TVDevice,
        IlluminationSensor,
        ModalWaiting,
        ModalAddDevice,
        HumidityDevice,
    },
    data() {
        return {
            categories: [ "Избранное",  "Все", ],
            locations: [],
            activeGroup: 1,
            devices: [],
            deviceTypes: deviceTypes,
            room: null,
            openModalWaiting: false,
            searchField: "",
            searchText: "",
            openAddDeviceModal: false,
        };
    },
    computed: {
        chosenLocation() {
            let step = this.hasOffline ? 2 : 1;
            return this.activeGroup > step ? this.locations[this.activeGroup] : "Выберите комнату";
        },
        devicesFiltered() {
            this.devices.forEach((el) => {
                el.show_favorite = true;
            });
            this.devices = this.devices.sort((a, b) => (a.name > b.name) ? 1 : -1);
            let searchDevices = JSON.parse(JSON.stringify(this.devices));
            if (this.activeGroup == 0) {
                this.devices.forEach((el) => {
                    el.show_favorite = false;
                });
                searchDevices = this.devices.filter((el) => {
                    return el.is_favorite == true && el.name.toLowerCase().includes(this.searchText.toLowerCase());
                });
            } else if (this.hasOffline && this.activeGroup == 2) {
                searchDevices = this.devices.filter((el) => {
                    return !el.online && el.name.toLowerCase().includes(this.searchText.toLowerCase());
                });
            } else if (this.activeGroup > 1) {
                searchDevices = this.devices.filter((el) => {
                    return el.location == this.locations[this.activeGroup] && el.name.toLowerCase().includes(this.searchText.toLowerCase());
                });
            } else if (this.searchText != "") {
                searchDevices = this.devices.filter((el) => {
                    return el.name.toLowerCase().includes(this.searchText.toLowerCase());
                });
            }
            return searchDevices;
        },
        locationsScroll() {
            if (this.locations && this.locations.length < 7) {
                return this.locations;
            }
            return this.categories;
        },
        hasOffline() {
            return this.devices.some((el) => !el.online);
        },
        showDeviceLocation() {
            return this.hasOffline ? [0, 1, 2].includes(this.activeGroup) : [0, 1].includes(this.activeGroup);
        },
    },
    watch: {
        room(val) {
            if (val) {
                this.getDevices();
                localStorage.RobohomeAdminTZ = val.timezone;
            }
        },
    },
    methods: {
        setSearch() {
            setTimeout(() => {
                this.searchText = this.searchField;
            });
        },
        getDevices() {
            this.locations = [];
            this.scenarios = [];
            this.openModalWaiting = true;
            if (this.categories.length > 2) {
                this.categories.splice(2, 1);
            }
            this.$http.get('/devices/home/devices-list/' + this.room.uid + '/')
                .then((response) => {
                    this.devices = response.data.devices;
                    if (this.devices.filter((el) => { return el.is_favorite == true }).length == 0) {
                        this.activeGroup = 1;
                    }
                    if (this.hasOffline) {
                        this.categories.push("Неисправные");
                    }
                    this.locations = JSON.parse(JSON.stringify(this.categories));
                    if (response.data.locations) {
                        response.data.locations.forEach((el) => {
                            if (el) {
                                this.locations.push(el);
                            }
                        });
                    }
                })
                .finally(() => {
                    this.$nextTick(() => {
                        if (this.$store.state.storeActiveGroup !== null) {
                            let i = this.locations.indexOf(this.$store.state.storeActiveGroup);
                            if (i !== -1) {
                                this.activeGroup = i;
                            }
                        }
                    });
                    this.openModalWaiting = false;
                });
        },
        setFavorite(item) {
            this.$http.put('/homes/home/device/favorites/', {
                device: item.uid,
                is_favorite: !item.is_favorite,
            })
                .then(() => {
                    item.is_favorite = !item.is_favorite;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onScroll(e) {
            this.offsetTop = e.target.scrollTop;
            this.$store.commit('setScroll', this.offsetTop);
        },
        setActiveGroup(index) {
            this.activeGroup = index;
            this.$store.commit("setActiveGroup", this.locations[this.activeGroup]);
        },
        openSheet() {
            this.$refs.BottomSheet.open();
        },
        openAddDevice() {
            this.openAddDeviceModal = true;
        },
        openUser() {
            let childwin = window.open('https://user.robohome.volhinsoft.ru');

            setTimeout(() => {
                childwin.postMessage(
                    this.$store.state.accessToken,
                    process.env.VUE_APP_USER_URL,
                );
            }, 1000);
        },
    },
}
</script>

<style lang="scss">
.main-container .devices-list.scroll-layout {
    height: calc(100% - 155px) !important;

    .img-center {
        position: relative;
        top: calc(50% - 155px) !important;
    }
}
</style>